module.exports = __webpack_public_path__ + "static/media/css.1123cff9.jpg";